import React from 'react';

import HasData from '../../../validate/HasData';

const HasEnrichmentCategory = props => {
    const {eventId, cat, to, ignore = [], children} = props;

    return (
        <HasData
            check={state =>
                Object.values(state.events[eventId]?.event.enrichment_categories || {}).find(enCat => {
                    return enCat.category == cat;
                }) || ignore.find(id => id == cat)
            }
            to={to}>
            {children}
        </HasData>
    );
};

export default HasEnrichmentCategory;
